let sdkPromise;

function loadVimeoSDK() {
  if (window.Vimeo && window.Vimeo.Player) {
    return Promise.resolve(window.Vimeo);
  }
  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timeout = window.setTimeout(() => reject(new Error('Vimeo SDK timeout')), 15000);
      script.src = 'https://player.vimeo.com/api/player.js';
      script.onload = () => {
        window.clearTimeout(timeout);
        if (window.Vimeo && window.Vimeo.Player) {
          resolve(window.Vimeo);
        } else {
          reject(new Error('Vimeo SDK unavailable'));
        }
      };
      script.onerror = () => {
        window.clearTimeout(timeout);
        reject(new Error('Vimeo SDK unavailable'));
      };
      document.head.appendChild(script);
    });
  }
  return sdkPromise;
}

function initVideo(block, Vimeo) {
  const iframe = block.querySelector('iframe');
  const button = block.querySelector('.video__play');
  const pauseButton = block.querySelector('.video__pause-overlay');
  const status = block.querySelector('.video__status');
  const player = new Vimeo.Player(iframe);
  let readyTimeout;

  const showNativePlayer = () => {
    window.clearTimeout(readyTimeout);
    block.classList.remove('video--ready');
    pauseButton.hidden = true;
    pauseButton.disabled = false;
    button.hidden = true;
    button.disabled = false;
    status.hidden = false;
    if (document.activeElement === button || document.activeElement === pauseButton) {
      iframe.focus();
    }
  };

  const onPlay = () => {
    block.classList.remove('video--ready');
    button.hidden = true;
    button.disabled = false;
    pauseButton.hidden = false;
    pauseButton.disabled = false;
    status.hidden = true;
    if (document.activeElement === button) {
      pauseButton.focus({ preventScroll: true });
    }
  };

  const onPause = () => {
    block.classList.add('video--ready');
    button.hidden = false;
    button.disabled = false;
    pauseButton.hidden = true;
    pauseButton.disabled = false;
    status.hidden = true;
    if (document.activeElement === pauseButton) {
      button.focus({ preventScroll: true });
    }
  };

  player.on('play', onPlay);
  player.on('pause', onPause);
  player.on('ended', onPause);
  player.on('error', showNativePlayer);


  button.addEventListener('click', () => {
    button.disabled = true;
    status.hidden = true;

    player.setMuted(false).catch(error => {
      console.warn('Vimeo: attivazione audio fallita', error);
    });

    player.play().then(onPlay).catch(showNativePlayer);
  });

  pauseButton.addEventListener('click', () => {
    pauseButton.disabled = true;
    player.pause().then(onPause).catch(showNativePlayer);
  });

  readyTimeout = window.setTimeout(showNativePlayer, 15000);
  player.ready().then(() => {
    window.clearTimeout(readyTimeout);
    block.classList.add('video--ready');
    button.hidden = false;
  }).catch(showNativePlayer);
}

function initVideos() {
  const blocks = Array.from(document.querySelectorAll('[data-mc-video]:not(.is-admin)'));
  if (!blocks.length) {
    return;
  }
  loadVimeoSDK().then(Vimeo => {
    blocks.forEach(block => {
      try {
        initVideo(block, Vimeo);
      } catch (error) {
        // The native iframe remains usable if custom controls cannot initialize.
        block.classList.remove('video--ready');
      }
    });
  }).catch(() => {
    // The native Vimeo controls remain available if the SDK cannot load.
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVideos, { once: true });
} else {
  initVideos();
}
